type CSS = { [K in keyof CSSStyleDeclaration]?: CSSStyleDeclaration[K] };

function createStyledElement<T extends HTMLElement = HTMLElement>(
  name: string,
  style: CSS = {},
  attr: any = {},
  events: { [key: string]: () => void } = {}
): (...children: Array<HTMLElement | string>) => T {
  return (...children: Array<HTMLElement | string>) => {
    const elem: T = document.createElement(name) as any;
    Object.keys(style).forEach(styleKey => {
      elem.style[styleKey] = style[styleKey];
    });
    Object.keys(attr).forEach(attrKey => {
      elem[attrKey] = attr[attrKey];
    });
    Object.keys(events).forEach(eventName => {
      elem.addEventListener(eventName as any, events[eventName]);
    });
    children.forEach(child => {
      const item = typeof child === 'string' ? document.createTextNode(child) : child;
      elem.appendChild(item);
    });
    return elem;
  };
}

export const ErrorWrapper = createStyledElement('div', {
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'center',
  fontSize: '20px',
  fontWeight: '100',
  overflowY: 'auto',
  padding: '20px',
  background: '#CFD8DC',
  color: '#263238',
  zIndex: '3000'
});

export const Title = createStyledElement('h2', {
  fontWeight: '100',
  marginBottom: '40px',
});

export const SubTitle = createStyledElement('h3', {
  fontWeight: '100',
  marginBottom: '40px',
  textAlign: 'center',
});

const clickableStyle: CSS = {
  background: 'white',
  border: 'none',
  borderRadius: '4px',
  fontSize: '16px',
  cursor: 'pointer',
  display: 'inline-block',
  color: '#424242',
  fontWeight: '100',
  padding: '5px 10px',
  lineHeight: '1.5',
};

export const Button = createStyledElement(
  'button',
  clickableStyle,
  {},
  {
    click: () => {
      window.location.reload();
    },
  }
);

export const Link = (href: string) =>
  createStyledElement(
    'a',
    {
      ...clickableStyle,
      textDecoration: 'none',
    },
    {
      href,
    }
  );

export const Instruction = createStyledElement('p', {
  margin: '20px',
  textAlign: 'center',
  lineHeight: '2',
});

export const ErrorDisplay = createStyledElement('pre', {
  fontSize: '12px',
  textAlign: 'left',
  fontFamily: 'monospace',
  maxWidth: '80%',
  background: 'white',
  color: 'black',
  padding: '20px',
  borderRadius: '4px',
  margin: '20px',
  letterSpacing: 'initial',
  overflow: 'auto',
});

export const div = createStyledElement('div', {});
export const br = createStyledElement('br', {});
export const GifImg = createStyledElement(
  'img',
  {},
  {
    src: 'https://media.giphy.com/media/3ohhwtMJ8RKS8JDI9a/giphy.gif',
    alt: 'Fail',
  }
);



// WEBPACK FOOTER //
// ./node_modules/front-system/engine/view/elements.ts